import OutcomesPerStudent from "./ConnectedOutcomesPerStudent.js";
import OutcomeSDKComponent from "./OutcomeSDKComponent.js";
export default OutcomeSDKComponent(OutcomesPerStudent);